












































  import { Component } from 'vue-property-decorator';
  import { GuardileoEditComponent } from '@/lib';
  import { RechtsgutachtenApi, Rechtsgutachten_Drittland_Info, LandInfo } from './api-rechtsgutachten';

  @Component({
components: {  },})
  export default class extends GuardileoEditComponent {
      private api: RechtsgutachtenApi = new RechtsgutachtenApi();

      private laender: any[] = [];
      private land: number | null = null;
      private textDe: string = "";
      private textEn: string = "";

      private editorOptionsDe = {
          placeholder: "Bitte geben Sie das Rechtsgutachten in deutscher Sprache ein...",            
          theme: 'snow',
          modules: {
              toolbar: [['bold', 'italic', 'underline']]
          },
      };

      private editorOptionsEn = {
          placeholder: "Bitte geben Sie das Rechtsgutachten in englischer Sprache ein...",            
          theme: 'snow',
          modules: {
              toolbar: [['bold', 'italic', 'underline']]
          },
      };

      async load() {
          const data = await this.guard_status(async () => await this.api.Laender_ohne());
          this.laender = 
              data
                  .filter((_: LandInfo) => !_.HatGutachten)
                  .map((_: LandInfo) => ({id: _.Id, text: _.Key}));
      }        

      get isDirty(): boolean {
          return this.isValid;
      }

      get isValid(): boolean {
          return this.land != null && this.textDe != null && this.textDe != "";
      }

      async save_changes(e: Event) {
          e.stopPropagation();
          e.preventDefault();
          if (!this.can_save) return;
          const land = this.land;
          if (!land) return;
          await this.guard_save(() => this.api.Aktualisieren(land, this.textDe, this.textEn));
          this.forceClean();
          this.$router.push({name: 'administration-einstellungen-rechtsgutachten'});
      }
  }
